/**
 * Create by lizj 2018/6/15
 */


;(function () {

    dialogDelCtrl.$inject = ['event', 'request'];
    angular
        .module('DSSXAPP')
        .component('dialogDel', {
            template:'<div class="dialog-del-component" ng-show="vm.d.showDialogDel"><div class="dialog-del-wrap"></div><div class="dialog-del zoomIn"><div class="dialog-del-title"><i class="iconfont icon-close" ng-click="vm.f.cancel()"></i></div><div class="dialog-del-content">您确认要删除这些信息吗？被删除到回收站的信息，24小时后才能恢复。</div><div class="dialog-del-footer"><button class="button-primary button-medium sure" ng-click="vm.f.sure()">确定</button> <button class="button-normal button-medium cancel" ng-click="vm.f.cancel()">取消</button></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: dialogDelCtrl
        });

    function dialogDelCtrl(event, request) {
        this.$onInit = onInit;

        var vm = this;

        vm.d = {
            showDialogDel: false,
            ids: []
        };

        vm.f = {
            sure: sure,
            cancel: cancel
        };

        function onInit() {
            initEvent();
        }

        function initEvent() {
            event.on('layout.showDialogDel', function (data) {
                vm.d.showDialogDel = data.type;
                vm.d.ids = [];
                for (var attr in data.selectData) {
                    if (data.selectData.hasOwnProperty(attr)) {
                        if (data.selectData[attr]) {
                            vm.d.ids.push(attr);
                        }
                    }
                }
            });

            event.on('layout.showDialogDelOne', function (data) {
                vm.d.showDialogDel = data.type;
                vm.d.ids = [];
                vm.d.ids.push(data.id);
            })
        }

        function sure() {
            var config = {
                ids: vm.d.ids,
                method: 'delByIds'
            };

            updateZeroEffectPrd(config);
            cancel();
        }

        function cancel() {
            vm.d.showDialogDel = false;
        }

        //跟新零效果产品
        function updateZeroEffectPrd(data) {
            return request.post('/usr/api/updateZeroEffectPrd', {}, data, true)
                .then(updateSuc, updateErr)
            ;

            function updateSuc(res) {
                if (res.code === 0) {
                    layer.msg('删除成功', {icon: 1});
                }
                ZeroEffectProductTMInterpolator()
                event.emit('reset-success');
            }

            function updateErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'dialogDelCtrl',
                    funcName: 'updateZeroEffectPrd',
                    text: 'dialogDelCtrl fail'
                });
            }
        }

        // 实训任务-零效果产品页插入逻辑
        function ZeroEffectProductTMInterpolator() {
            var TM = DSSX.TrainingMission;

            return TM.tryStart(TM.MissionType.ZeroEffectProduct, {bindId: '', bindInfo: ''})
                .then(tryStartTMSuc, tryStartTMErr);

            function tryStartTMSuc(tmc) {
                console.log('[inqChatCtrl] TM tmc: ', tmc);
                // 没有任务需要同步或同步失败
                if (!tmc) {
                    // do something
                }
            }

            function tryStartTMErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'SelfProductCtrl',
                    funcName: 'tryStart',
                    text: '实训任务错误',
                });
                console.log('[TM] tryStartTMErr', err);
            }
        }

    }

})();

